export const caseInsensitiveTextSortAsc= (a, b) =>{
    const aValue= (a||'').toLowerCase();
    const bValue=(b||'').toLowerCase();
   return aValue < bValue ? -1 : 1;
} 

export const caseInsensitiveTextSortDesc= (a, b) =>{
    return caseInsensitiveTextSortAsc(a,b)*-1;
 } 